import Cookies from 'js-cookie';
import { KioskCookies } from '../../../../helpers/Cookies';
import type { SavedSessionCookieData } from '../../SavedSession.types';
import type { HasSavedSessionFunction } from './hasSavedSession.types';

/**
 * Checks whether a SavedSession cookie is currently present and parses to a
 * truthy {@link SavedSessionCookieData} value. Returns `true` when the cookie
 * exists and contains data, otherwise `false`.
 */
export const hasSavedSession: HasSavedSessionFunction = () => {
    const cookie: string | undefined = Cookies.get(KioskCookies.SavedSession);

    if (cookie) {
        try {
            const data: SavedSessionCookieData = JSON.parse(cookie);

            return !!data;
        }
        catch {
            return false;
        }
    }
    else {
        return false;
    }
};